import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NFormComponent } from '@pebula/nform';
import { InspectorModel } from '../../inspector-form-model';

@Component({
  selector: 'sg-inspector-expanded-search',
  templateUrl: './inspector-expanded-search.component.html',
  styleUrls: ['./inspector-expanded-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgInspectorExpandedSearchComponent {
  @Input() inspectorFormModel: InspectorModel;
  @Output() onClick = new EventEmitter<void>();
  @ViewChild('expandedSearchForm', { read: NFormComponent, static: true }) expandedSearchForm: NFormComponent;

  relevantFields = ['isin', 'dateRange', 'units', 'bic'];

  inspectOutboundFolderClicked(): void {
    const expandedSearchCriteria = this.relevantFields.reduce((dataToCommit, field) => {
      dataToCommit[field] = this.expandedSearchForm.form.controls[field].value;
      return dataToCommit;
    }, {});
    Object.assign(this.inspectorFormModel, expandedSearchCriteria);
    this.onClick.emit();
  }
}
